import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store/store';
import { RouteComponentProps } from "@reach/router";
import styled from 'styled-components';
import { Filters } from './Filters';
import { Schedules } from './Schedules';
import { Reports } from './Reports';
import { NewActions } from './NewActions';
import { isJsonEqual } from '../../../lib/typeCheck';
import { StandardButton } from '../../common/fields/Buttons';
import { usePrevious } from '../../../lib/hooks';

import { selectAllReportSchedules, fetchReportSchedules, toggleActive } from '../../../store/data-export/reportSchedulesSlice';
import { selectCustomer, editCustomer, fetchCustomer } from '../../../store/data-export/customersSlice';
import { selectAllNodePositions } from '../../../store/positions/menuNodesSlice';

import { fetchPositionsReportData, selectResolvedReports, selectResolvedSchedules } from '../../../store/data-export/report';
import { ResolvedReportSlice, ResolvedReportScheduleSlice } from '../../../store/data-export/types';
import { selectAllReports } from '../../../store/data-export/reportsSlice';
import { selectAllReportTemplates } from '../../../store/data-export/reportTemplatesSlice';

import { fetchUsers, selectUsers } from '../../../store/users/usersSlice';

const StyledDataExport = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

const HeadingSpace = styled.div`
  width: 100%;
  height: 50px;
  box-sizing: border-box;
`;

const ContentContainer = styled.div`
  width: 90%;
  margin: 50px auto 0 auto;
  box-sizing: border-box;
`;

const Divider = styled.div`
  width: 100%;
  height: 0;
  margin: 30px 0;
  border-top: 1px dashed #C4C4C4;
`;

export const isSelectedNodesJsonEqual = (a, b) => {
  console.log(JSON.stringify(a) === JSON.stringify(b));
  return JSON.stringify(a) === JSON.stringify(b);
}

export const isCustomerJsonEqual = (a, b) => {
  console.log('customer - ' + (JSON.stringify(a) === JSON.stringify(b)));
  return false;
  // return JSON.stringify(a) === JSON.stringify(b);
}

export const isUsersJsonEqual = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
}

export const DataExport = (props: RouteComponentProps) => {
  console.log('re rendering')
  const dispatch = useDispatch();
  
  const users = useSelector(selectUsers, isJsonEqual);
  const customers = useSelector(selectCustomer, isJsonEqual);
  
  const selectedNodes = useSelector(selectAllNodePositions, isJsonEqual);
  const prevSelectedNodes = usePrevious(selectedNodes);
  
  const resolvedReports: ResolvedReportSlice[] = useSelector(selectResolvedReports, isJsonEqual) || [];
  const resolvedReportSchedules: ResolvedReportScheduleSlice[] = useSelector(selectResolvedSchedules, isJsonEqual) || [];
  const reportTemplates = useSelector(selectAllReportTemplates, isJsonEqual) || [];
  
  useEffect(() => {
    // useEffect only uses a shallow comparison so manually deep check against
    // previous state
    if (selectedNodes.length > 0 && !isJsonEqual(selectedNodes, prevSelectedNodes)) {
      dispatch(fetchPositionsReportData())
    }
  }, [selectedNodes]);
  
  useEffect(() => {
    dispatch(fetchUsers());
  }, []);
  
  return (
    <StyledDataExport>
      <HeadingSpace/>
      <Filters/>
      <ContentContainer>
        <Schedules reportSchedules={resolvedReportSchedules} reportTemplates={reportTemplates} />
        <NewActions>
          <StandardButton background='#233567' disabled={false}>New Schedule</StandardButton>
          <StandardButton background='#233567' disabled={false}>New Report</StandardButton>
        </NewActions>
        <Divider/>
        <Reports reports={resolvedReports}/>
      </ContentContainer>
    </StyledDataExport>
  )
}